export default __webpack_public_path__ + "static/media/h6.521fbf82.jpg";